export default __webpack_public_path__ + "static/media/three_mead_friends.abe3780e.jpg";